/* FOSSILGLOW Editorial Share System v2 */
(function(){
  'use strict';
  
  /* 1. Inject editorial share CSS */
  if(!document.getElementById('fg-share-css')){
    var style=document.createElement('style');
    style.id='fg-share-css';
    style.textContent=[
      'share-button .share-button__button,share-button details,share-button .share-button__fallback{display:none!important}',
      '.fg-share{position:relative;text-align:center;padding:2.5rem 0 1rem;margin:1.5rem auto 0;max-width:74rem}',
      '.fg-share__btn{display:inline-flex;align-items:center;gap:.4em;background:none;border:none;padding:.5rem 0;font-family:Noto Sans,Helvetica,Arial,sans-serif;font-size:.72rem;letter-spacing:.14em;text-transform:uppercase;color:rgba(42,37,32,.45);cursor:pointer;min-height:44px;min-width:44px;line-height:1;transition:color .25s ease}',
      '.fg-share__btn:hover,.fg-share__btn:focus-visible{color:rgba(42,37,32,.75);outline:none}',
      '.fg-share__btn:focus-visible{outline:2px solid rgba(42,37,32,.3);outline-offset:4px;border-radius:2px}',
      '.fg-share__arrow{display:inline-block;font-size:.85em;transition:transform .2s ease}',
      '.fg-share__btn:hover .fg-share__arrow{transform:translate(2px,-2px)}',
      '.fg-share__ok{display:block;margin-top:.5rem;font-family:Noto Sans,Helvetica,Arial,sans-serif;font-size:.65rem;letter-spacing:.12em;text-transform:uppercase;color:rgba(42,37,32,.4);opacity:0;transition:opacity .3s ease}',
      '.fg-share__ok.is-on{opacity:1}',
      '.article-template .fg-share{margin-top:2rem;margin-bottom:1rem}',
      '@media(min-width:750px){.fg-share{padding:3rem 0 1.5rem}.fg-share__btn{font-size:.75rem}}'
    ].join('\n');
    document.head.appendChild(style);
  }
  
  /* 2. Determine share label based on page context */
  function getLabel(){
    var p=window.location.pathname;
    if(p.indexOf('/blogs/')===0) return 'SHARE THIS STORY \u2197';
    if(p.indexOf('field-note')>=0||p.indexOf('growing-up')>=0) return 'SHARE THIS FIELD NOTE \u2197';
    return 'SHARE \u2197';
  }
  
  /* 3. Upgrade a <share-button> element to editorial UI */
  function upgradeShareButton(sb){
    if(sb.dataset.fgUpgraded) return;
    sb.dataset.fgUpgraded='1';
    
    // Get share URL from the hidden input
    var urlInput=sb.querySelector('input[id^="ShareUrl"]');
    var shareUrl=urlInput?urlInput.value:window.location.href;
    var label=getLabel();
    
    // Build editorial share UI
    var wrap=document.createElement('div');
    wrap.className='fg-share';
    
    var btn=document.createElement('button');
    btn.className='fg-share__btn';
    btn.type='button';
    btn.setAttribute('aria-label','Share this page');
    btn.setAttribute('data-url',shareUrl);
    btn.innerHTML=label+' <span class="fg-share__arrow" aria-hidden="true">\u2197</span>';
    
    var ok=document.createElement('span');
    ok.className='fg-share__ok';
    ok.setAttribute('role','status');
    ok.setAttribute('aria-live','polite');
    ok.textContent='LINK COPIED';
    
    wrap.appendChild(btn);
    wrap.appendChild(ok);
    sb.style.display='block';
    sb.appendChild(wrap);
    
    // Bind click handler
    btn.addEventListener('click',function(){
      var u=btn.getAttribute('data-url')||window.location.href;
      if(navigator.share){
        navigator.share({url:u,title:document.title}).catch(function(){});
      }else if(navigator.clipboard&&navigator.clipboard.writeText){
        navigator.clipboard.writeText(u).then(function(){
          ok.classList.add('is-on');
          setTimeout(function(){ok.classList.remove('is-on');},2200);
        });
      }else{
        var ta=document.createElement('textarea');
        ta.value=u;ta.style.position='fixed';ta.style.opacity='0';
        document.body.appendChild(ta);ta.select();
        try{document.execCommand('copy');}catch(e){}
        document.body.removeChild(ta);
        ok.classList.add('is-on');
        setTimeout(function(){ok.classList.remove('is-on');},2200);
      }
    });
  }
  
  /* 4. Find and upgrade all share-button elements */
  function upgradeAll(){
    document.querySelectorAll('share-button').forEach(upgradeShareButton);
  }
  
  // Run on DOM ready
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',upgradeAll);
  }else{
    upgradeAll();
  }
  
  // Also watch for late-loading share buttons
  var obs=new MutationObserver(function(){upgradeAll();});
  obs.observe(document.body||document.documentElement,{childList:true,subtree:true});
  
  // Re-run periodically for a few seconds to catch late renders
  var retries=0;
  var interval=setInterval(function(){
    upgradeAll();
    retries++;
    if(retries>=10) clearInterval(interval);
  },500);
})();
